/**
 * Note display configuration.
 *
 * Well-known managed list names for note types and tags.
 * Fallback arrays used when managed lists haven't been created yet.
 */

/** Managed list name for note types */
export const NOTE_TYPES_LIST_NAME = 'Note Types';

/** Managed list name for note tags */
export const NOTE_TAGS_LIST_NAME = 'Note Tags';

/** Default fallback note types (used when managed list is empty) */
export const DEFAULT_NOTE_TYPES = [
  'General Note',
  'Renewal Update',
  'Broker Conversation',
  'Implementation Update',
  'Pricing Discussion',
  'Upsell Discussion',
  'Blocker / Issue',
  'Client Feedback',
  'Internal Coordination',
];

/** Default fallback note tags (used when managed list is empty) */
export const DEFAULT_NOTE_TAGS = [
  'broker-concern',
  'pricing',
  'upsell-opportunity',
  'positive-signal',
  'timeline-risk',
  'action-needed',
  'waiting-on-client',
  'waiting-on-vendor',
];

/** Default color for items without a color set */
export const DEFAULT_TAG_COLOR = '#6B7280';
export const DEFAULT_TYPE_COLOR = '#6B7280';
